import { i } from "./isNotNil-DCWUsql8.mjs";
import { n as o } from "./nullToUndefined-Ba7Hd5zS.mjs";
function p(n, r) {
  return arguments.length === 2 && i(n) && i(r) ? o(r[n]) : arguments.length === 1 ? (t) => t ? o(t[n]) : void 0 : void 0;
}
export {
  p
};
//# sourceMappingURL=prop-BQhMHusR.mjs.map
